import { Coordinate, DEFAULT_START_LOCATION } from "../types/coordinate";
import { useLanguageStore } from "../store/languageStore";
import { useNavigationStore } from "../store/navigationStore";
import { findNavPath } from "../utils/navigation";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentPosition } from "../utils/geolocation";
import { v4 as uuidv4 } from "uuid";
import { useAppStore } from "../store/appStore";

import sampleRouteWKS from "src/api/route_wks.json";
import sampleRouteWKS2 from "src/api/route_wks2.json";
import sampleRouteWKS3 from "src/api/route_wks3.json";
import sampleRouteEntranceToTea from "src/api/route_entrance_to_tea.json";
import sampleRouteEntranceToStudio1 from "src/api/route_entrance_to_studio1.json";
import sampleRouteAtriumToStarPlace from "src/api/route_atrium_to_star_place.json";
import sampleRouteTicketToGrandTheatre from "src/api/route_ticket_to_grand_theatre.json";
import { getVenue18nName } from "@/utils/map-util";

export function useFindPath(redirectToNav: boolean = false) {
  const userId = useAppStore((state) => state.userId);
  // const conversationId = useNavigationStore((state) => state.conversationId);
  const currentNavMode = useNavigationStore((state) => state.currentMode);
  const setUserId = useAppStore((state) => state.setUserId);
  const setNavData = useNavigationStore((state) => state.setNavData);

  const setVenueNotSupported = useNavigationStore(
    (state) => state.setVenueNotSupported,
  );
  const setUserQuery = useNavigationStore((state) => state.setUserQuery);
  const setApiError = useNavigationStore((state) => state.setApiError);
  const appLanguage = useLanguageStore((state) => state.appLanguage);
  const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);
  let navigate = useNavigate();
  const setLoading = useNavigationStore((state) => state.setLoading);
  const setInterrupt = useNavigationStore((state) => state.setInterrupt);
  const traceId = useNavigationStore((state) => state.traceId);
  const setTraceId = useNavigationStore((state) => state.setTraceId);
  const setNavFrom = useNavigationStore((state) => state.setNavFrom);

  const appendChatHistory = useNavigationStore(state => state.appendChatHistory);


  const handleUserQuery = useCallback(
    async (
      userQuery: string,
      options?: {
        useCurrentLocation?: boolean;
        mode?: string;
        startVenueId?: string;
        startMapId?: string;
        startCoordinate?: string;
        startPoi?: string;
      },
    ) => {
      const { useCurrentLocation = false, mode = currentNavMode } =
        options || {};

      var user = userId;
      if (!userId) {
        user = uuidv4();
        setUserId(user);
      }

      var trace = traceId;
      if (!traceId) {
        trace = uuidv4();
        setTraceId(trace);
      }
      console.log("trace", trace);

      try {
        setLoading(true);
        // if (redirectToNav) {
        //   navigate("/loading");
        // }
        console.log("handleUserQuery: redirectToNav=", redirectToNav);
        console.log("useCurrentLocation=", useCurrentLocation);

        let coordinate: Coordinate;
        if (!useCurrentLocation) {
          coordinate = DEFAULT_START_LOCATION;
        } else {
          const locationResult = await getCurrentPosition();

          if (locationResult.success && locationResult.data) {
            coordinate = locationResult.data;
            console.log("Using current location:", coordinate);
          } else {
            coordinate = DEFAULT_START_LOCATION;
            console.log("Using fallback location:", coordinate);
          }
        }

        console.log("mode: ", mode);
        setUserQuery(userQuery);
        // setApiError("");
        // setVenueNotSupported(false);

        // if (
        //   userQuery == "Show me how to get from Ticket Office to Tea House Theatre in Xiqu Centre." ||
        //   userQuery == "告訴我如何從戲曲中心售票處前往茶館劇院。" ||
        //   userQuery == "告诉我如何从戏曲中心售票处前往茶馆剧院。"
        // )
        if (
          userQuery ==
          "Show me how to get from L1 Exit (Element) to Self-service Taxi Ticket in West Kowloon Station." ||
          userQuery ==
          "告訴我如何從西九龍站 L1 出口(圓方)前往自助的士取號機。" ||
          userQuery == "告诉我如何从西九龙站 L1 出口(圆方)前往自助的士取号机。"
        ) {
          await setNavData(sampleRouteWKS, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
          "Show me how to get from Meeting Point 3 to MX in West Kowloon Station." ||
          userQuery == "告訴我如何從西九龍站集合處3 前往美心MX。" ||
          userQuery == "告诉我如何从西九龙站集合处3 前往美心MX。"
        ) {
          await setNavData(sampleRouteWKS2, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
          "Show me how to get from Information Counter to Self-service ticket purchase in West Kowloon Station." ||
          userQuery == "告訴我如何從西九龍站詢問處前往自助購票。" ||
          userQuery == "告诉我如何从西九龙站询问处前往自助购票。"
        ) {
          await setNavData(sampleRouteWKS3, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
          "Show me how to get from Main Entrance to Tea House Theatre in Xiqu Centre." ||
          userQuery == "告訴我如何從戲曲中心正門前往茶館劇院。" ||
          userQuery == "告诉我如何从戏曲中心正门前往茶馆剧院。"
        ) {
          await setNavData(sampleRouteEntranceToTea, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
          "Show me how to get from Main Entrance to Studio 1 in Xiqu Centre." ||
          userQuery == "告訴我如何從戲曲中心正門前往排演室1。" ||
          userQuery == "告诉我如何从戏曲中心正门前往排演室1。"
        ) {
          await setNavData(sampleRouteEntranceToStudio1, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
          "Show me how to get from Atrium to Star Place in Xiqu Centre." ||
          userQuery == "告訴我如何從戲曲中心中庭前往明星樓。" ||
          userQuery == "告诉我如何从戏曲中心中庭前往明星楼。"
        ) {
          await setNavData(sampleRouteAtriumToStarPlace, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
          "Show me how to get from Ticket Office to Grand Theatre in Xiqu Centre." ||
          userQuery == "告訴我如何從戲曲中心售票處前往大劇院。" ||
          userQuery == "告诉我如何从戏曲中心售票处前往大剧院。"
        ) {
          await setNavData(sampleRouteTicketToGrandTheatre, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else {
          var pathOptions = {};

          if (
            options?.startVenueId !== "" &&
            options?.startMapId !== "" &&
            options?.startCoordinate !== "" &&
            options?.startPoi !== ""
          ) {
            pathOptions = {
              startVenueId: options?.startVenueId,
              startMapId: options?.startMapId,
              startCoordinate: options?.startCoordinate,
              startPoi: options?.startPoi
            };
          }
          console.log("useFindPath pathOptions:", pathOptions);
          appendChatHistory({ from: 'user', message: userQuery })
          const result = await findNavPath(
            appLanguage,
            userQuery,
            mode,
            user,
            // conversationId,
            trace,
            coordinate,
            pathOptions,
          );
          console.log("result", result);
          if (
            result.success &&
            result.data &&
            result.data.nav.length > 0 &&
            result.data.nav[0].navigation != null
          ) {
            await setNavData(result.data, voiceLanguage);
            appendChatHistory({ from: 'bot', message: result.data.message })
            // setLoading(false);
            setInterrupt(false);
            console.log("navigate to navigation: userQuery:", userQuery);
            console.log("result.data:", result.data);

            if (result.data.nav[0].navigation.length > 0) {
              // extract first node message, and remove "Start at"
              setNavFrom(result.data.nav[0]?.startingPoi.name ?? "");
            }
            if (redirectToNav) {
              navigate("/navigation");
            }
          } else if (
            result.success &&
            result.data &&
            (result.data.nav.length == 0 ||
              (result.data.nav.length > 0 &&
                result.data.nav[0].navigation == null))
          ) {
            appendChatHistory({ from: 'bot', message: result.data.message })
            setApiError(result.data.message);
            // if (result.data.nav.length == 0) {
            //   setVenueNotSupported(true);
            // }
            navigate("/");
          } else if (!result.success) {
            const error = result.error ?? "An error has occurred"
            setApiError(error);
            appendChatHistory({ from: 'bot', message: error })
            // setLoading(false);
            setInterrupt(false);
            navigate("/");
          } else {
            setVenueNotSupported(true);
            // setLoading(false);
            setInterrupt(false);
            navigate("/");
          }
        }
      } catch (e) {
        setVenueNotSupported(true);
        setInterrupt(false);
        navigate("/");
        console.error("Failed to find navigation path:", e);
      } finally {
        setLoading(false);
      }
    },
    [
      appLanguage,
      // conversationId,
      currentNavMode,
      navigate,
      setNavData,
      setVenueNotSupported,
      setApiError,
      setUserId,
      setUserQuery,
      userId,
    ],
  );

  return { handleUserQuery };
}
